export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Common.json?hash=e41b4edd080f39b8dcb69024f6d57525";